import '../less/index.less'

import $ from 'jquery'
window.jQuery = $
window.$ = $

const WOW = require('wowjs');

window.wow = new WOW.WOW({
    live: false
});

window.wow.init();

const Lazy = require('../../node_modules/jquery-lazy/jquery.lazy');

import 'js/appRouter'
import '../../node_modules/jquery-validation/dist/localization/messages_tr';
import '../../node_modules/jquery-validation/dist/jquery.validate';
import '../../node_modules/jquery-mask-plugin/dist/jquery.mask';

import './theme-files/nouislider/nouislider.min.js';
import './theme-files/owl-carousel/owl.carousel.min.js';
import './theme-files/bootstrap/js/bootstrap.bundle.min.js';
import './theme-files/imagesloaded.pkgd.min.js';
// import './theme-files/masonry.pkgd.min.js';
import './theme-files/jquery.matchHeight-min.js';
import './theme-files/slick/slick/slick.min.js';
import './theme-files/jquery-bar-rating/dist/jquery.barrating.min.js';
import './theme-files/slick-animation.min.js';
import './theme-files/lightGallery-master/dist/js/lightgallery-all.min.js';
import './theme-files/select2/dist/js/select2.full.min.js';
import './theme-files/main.js';

import common from 'js/common/index';

(function () {
  common();

  $('.lazy').Lazy({
    // your configuration goes here
    scrollDirection: 'vertical',
    effect: 'fadeIn',
    visibleOnly: true,
    onError: function(element) {
      console.log('error loading ' + element.data('src'));
    },
    
  });

  const currentLanguage = $('body').data('current-lang');
  if(currentLanguage) 
  {
    const LANG = require(`./lang/${currentLanguage}.js`);
    window.LANG  = LANG;
  }

  $('[data-phone-mask]').mask("0(500) 000 00 00", {
    placeholder: "0(500) 000 00 00"
  });
  $('[data-date-mask]').mask("00.00.0000", {
    placeholder: "gg.aa.YYYY"
  });
})();
